import { styled } from '@mui/system'
import { Box as MuiBox, Stack, useMediaQuery, useTheme } from '@mui/material'
import SlideInModal from 'components/Modal/SlideInModal'
import { CardPreviewLayoutProvider } from 'packages/ui/CardPreview/CardPreviewLayoutContext'

const MainContent = styled(Stack)(() => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  flexGrow: 1,
  height: 0
}))

export const TableContent = styled(MuiBox)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column',
  gap: theme.spacing(1),
  overflow: 'hidden',
  marginTop: '1rem'
}))

export const SideContent = styled(MuiBox)(({ theme, padding }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(4),
  width: 'clamp(300px, 36vw, 500px)',
  minWidth: 300,
  minHeight: 0,
  maxHeight: '100%',
  border: 'none',
  borderRadius: 0,
  padding: padding !== undefined ? padding : 0,
  backgroundColor: 'transparent',
  marginTop: '1rem',
  marginLeft: theme.spacing(2),
  overflow: 'hidden'
}))

export const ResponsiveSideContent = ({
  children,
  onClose,
  modalWidth = '480px',
  modalContentSx = {},
  ...props
}) => {
  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  if (isLargeScreen || !onClose) {
    return <SideContent {...props}>{children}</SideContent>
  }

  return (
    <SlideInModal
      onClose={onClose}
      hideHeader
      noPadding
      width={isSmallScreen ? '100%' : modalWidth}
      fullScreen={isSmallScreen}
    >
      <CardPreviewLayoutProvider value="slideIn">
        <MuiBox
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            minHeight: 0,
            boxSizing: 'border-box',
            py: 2,
            px: { xs: 2, sm: 4 },
            ...modalContentSx
          }}
        >
          {children}
        </MuiBox>
      </CardPreviewLayoutProvider>
    </SlideInModal>
  )
}

export const FiltersContainer = styled(MuiBox)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 16
}))

export default MainContent
